<template>
    <div class="panel">
        <h4 class="emp-h4">{{ label }}</h4>
        <div class="emp-tag-row">
            <span v-for="(item, i) in list" :key="i" class="emp-tag" title="Click to remove" @click="removeItem(i)">{{ item }}</span>
            <input v-if="adding" ref="tagInput" v-model="newItem" type="text" class="emp-tag-input" @keyup.enter="commitAdd()" @keyup.esc="cancelAdd()" @blur="commitAdd()" />
            <span v-else class="emp-tag emp-tag-add" @click="startAdd()">Add</span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'EmployeeTagPanel',
    props: [ 'employeeId', 'endpoint', 'label', 'items' ],
    components: {

    },
    data() {
        return {
            list: [] as any,
            adding: false,
            newItem: ''
        }
    },
    created() {
        this.list = JSON.parse(JSON.stringify(this.items || []));
    },
    methods: {
        startAdd() {
            this.newItem = '';
            this.adding = true;
            this.$nextTick(() => {
                (this.$refs.tagInput as HTMLInputElement)?.focus();
            });
        },
        cancelAdd() {
            this.adding = false;
            this.newItem = '';
        },
        async commitAdd() {
            if(!this.adding) {
                return;
            }
            const val = this.newItem.trim();
            this.adding = false;
            this.newItem = '';
            if(!val) {
                return;
            }
            this.list.push(val);
            await this.save();
        },
        async removeItem(i: number) {
            this.list.splice(i, 1);
            await this.save();
        },
        async save() {
            await axios.post(`${this.$store.state.apiUrl}/api/employees/${this.endpoint}`, { ID: this.employeeId, Items: this.list })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })
        }
    }
});
</script>
